"use client";

import { c as _c } from "react/compiler-runtime";
import { PauseCircle, LogOut } from "lucide-react";
import Image from "next/image";
import { useClerk } from "@clerk/nextjs";
import { SuperAdminBillingGateExemptLockoutControl } from "./super-admin-billing-gate-exempt-control";
const DEFAULT_SUPPORT_EMAIL = "support@cova.ai";
interface BillingPendingPageProps {
  /**
   * The product's own support address (`supportEmailOf(scope)`, R7 AC2). A
   * product that has not declared one keeps the address this page always showed.
   */
  readonly supportEmail?: string | null;
}
export function BillingPendingPage(t0) {
  const $ = _c(24);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    supportEmail
  } = t1;
  const clerk = useClerk();
  const email = supportEmail ?? DEFAULT_SUPPORT_EMAIL;
  let t2;
  if ($[2] !== clerk) {
    t2 = () => clerk.signOut({
      redirectUrl: "/sign-in"
    });
    $[2] = clerk;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LogOut className="h-3.5 w-3.5" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <button onClick={t2} className="absolute right-4 top-4 flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors">{t3}Sign out</button>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex justify-center mb-10"><Image src="/covalogo.png" alt="Cova Logo" width={120} height={40} priority={true} /></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex justify-center mb-6"><PauseCircle className="h-16 w-16 text-slate-400" strokeWidth={1.5} /></div>;
    t7 = <h1 className="text-2xl font-semibold text-slate-900 text-center mb-3">Almost ready</h1>;
    t8 = <p className="text-sm text-slate-600 text-center leading-relaxed max-w-sm mx-auto">Your organisation admin needs to complete the billing setup before you can access Cova. Please contact them to get started.</p>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
  }
  const t9 = `mailto:${email}`;
  let t10;
  if ($[11] !== t9) {
    t10 = <a href={t9} className="text-sm text-slate-500 hover:text-slate-700 underline underline-offset-2">Contact Support</a>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== email) {
    t11 = <p className="text-xs text-slate-400 mt-2">{email}</p>;
    $[13] = email;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = <div className="mt-10 text-center">{t10}{t11}</div>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SuperAdminBillingGateExemptLockoutControl />;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t12) {
    t14 = <div className="w-full max-w-md">{t5}{t6}{t7}{t8}{t12}{t13}</div>;
    $[19] = t12;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t14 || $[22] !== t4) {
    t15 = <div className="relative min-h-screen bg-white flex flex-col items-center justify-center px-4 py-12">{t4}{t14}</div>;
    $[21] = t14;
    $[22] = t4;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  return t15;
}